<template>
  <div
    style="background-color: #262d4a; font-family: Montserrat"
    :style="{ 'background-color': $route.name == 'VideoViewer' ? '#000000' : '#262d4a' }"
    class="layout--main"
    :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]"
    id="teacher-dashboard"
  >
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <the-navbar
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]" :isSideBarBactive="isSideBarBactive" @toggleSideBar="toggleSideBar"
        />

        <div id="teacher-view" class="router-view" :class="windowWidth < 838 && isSideBarBactive ? 'side-nav-active-router-view' : ''">
          <vx-card :class="windowWidth < 838 && isSideBarBactive ? 'side-nav-active' : ''" class="teacher__side-menu">
            <div v-for="(item, index) in sidebarItems" :key="index" class="w-full mb-3">
              <span class="pl-1 cursor-pointer flex" :class="[{'active-button': routeName == item.slug}, {'side-menu__button': routeName != item.slug}]" @click="navigate(item)">
                <feather-icon :icon="item.icon" svg-classes="stroke-current mr-2 pr-2"></feather-icon>
                <p class="ml-2">{{ item.name }}</p>
              </span>
            </div>
          </vx-card>
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden', 'side-nav-active-router-content': windowWidth < 838 && isSideBarBactive, 'smaller-content-area': windowWidth < 838}">
            <div class="content-area__content" :class="{'ml-5':windowWidth >= 838}">
              <back-to-top bottom="5%" visibleoffset="30" v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg back-to-top_btn"
                />
              </back-to-top>
               <div v-if="$route.name == 'Dashboard'" id="guardian-breadcrumbs" class="vx-row mb-2">
                <div class="vx-col">
                  <div class="flex bread-crumbs-container" style="align-items: baseline;flex-wrap: wrap;">
                    <!-- <div class="mr-2 flex cursor-pointer" style="height: 16px" @click="backToStudents">
                      <span><feather-icon class="mr-1" icon="HomeIcon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                    </div> -->
                    <div v-for="(item, index) in breadcrumbs" :key="index" class="flex" style="align-items: baseline;">
                      <span v-if="item.text != 'Task'"><feather-icon class="ml-2" :icon="item.icon" svg-classes="stroke-current h-4 w-4"></feather-icon></span>
                      <div v-if="item.text != 'Task'" class="mx-2 flex bread-crumbs-Item" style="height: 16px" @click="(index < (breadcrumbs.length - 1)) && item.clickFunction ? handleFunctionCall(item.clickFunction, $event) : null">
                        <h6 :class="[{'underline__hover-only': breadcrumbs.length > 1 && (index < (breadcrumbs.length - 1))}]" style="text-transform: capitalize;">{{item.text}}</h6>
                      </div>
                      <h6 v-if="breadcrumbs.length > 1 && (index < (breadcrumbs.length - 1))">/</h6>
                    </div>
                  </div>
                </div>
              </div>
              <transition :name="routerTransition" mode="out-in">
                <router-view :subjectViewActive="subjectViewActive" @changeRouteTitle="changeRouteTitle" @updateBreadcrumbs="updateBreadcrumbs"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import TheNavbar from "@/digicampus/components/DigiNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "../components/principalSidebarItems.js";
import BackToTop from "vue-backtotop";
// import Dashboard from "../teacherdashboard/Dashboard.vue";

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "static",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeName: this.$route.name,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      activeLink: false,
      to: "DigiCourseBuilder",
      breadcrumbs: [],
      dashboardComponent: null,
      isSideBarBactive:false,
      subjectViewActive:false,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      this.routeName = this.$route.name;
    },
    isThemeDark(val) {
      if (val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating",
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static",
      };
    },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    virtualClassroom(){
      var virtualClassroomCheck = false;
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        virtualClassroomCheck = JSON.parse(localStorage.getItem('userSiteInfo'))[0].virtualClassroom == undefined ? true: JSON.parse(localStorage.getItem('userSiteInfo'))[0].virtualClassroom;
      else 
        virtualClassroomCheck = JSON.parse(localStorage.getItem('userSiteInfo')).virtualClassroom == undefined ? true: JSON.parse(localStorage.getItem('userSiteInfo')).virtualClassroom;

      if(!virtualClassroomCheck){
        self.sidebarItems = sidebarItems.filter(x=> x.slug.match("TeacherBrowseContent")  || x.slug.match("TeacherLibrary"));
      }
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    navigate(item) {
      var self = this;
      self.to = item.slug;
      this.isSideBarBactive = false;
      self.$router.push({ url: item.url });
    },
    updateTheme() {
      this.$setColors();
    },
    handleFunctionCall(functionName, event) {
      this[functionName](event);
    },
    backToGrades(){
      this.dashboardComponent.isGradesViewActive = true;
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isGradeSubjectViewActive = false
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = false
      this.dashboardComponent.subjectViewActive = false;
      this.updateBreadcrumbs("remove", "backToGrades");
    },
    backToSubjectGrades(){
      this.dashboardComponent.isGradesViewActive = false;
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isGradeSubjectViewActive = true
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = false;
      this.dashboardComponent.subjectViewActive = false;
      this.updateBreadcrumbs("remove", "backToSubjectGrades");
    },
    backToStudents() {
      this.dashboardComponent.isSubjectsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isStudentsViewActive = true;
      this.subjectViewActive = false;

      this.updateBreadcrumbs("remove", "backToStudents");
    },
    backToSubjects() {
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = true;
      this.subjectViewActive = true;
      this.updateBreadcrumbs("remove", "backToSubjects");
    },
    backToModules() {
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isModulesViewActive = true;
      this.subjectViewActive = false;

      this.updateBreadcrumbs("remove", "backToModules");
    },
    backToTopics() {
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isTopicsViewActive = true;
      this.subjectViewActive = false;

      this.updateBreadcrumbs("remove", "backToTopics");
    },
    backToTasks() {
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isClassroomViewActive = false;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isTasksViewActive = true;
      this.subjectViewActive = false;

      this.updateBreadcrumbs("remove", "backToTasks");
    },
    backToClassroom(){
      this.dashboardComponent.isGradesViewActive = false;
      this.dashboardComponent.isStudentsViewActive = false;
      this.dashboardComponent.isModulesViewActive = false;
      this.dashboardComponent.isTopicsViewActive = false;
      this.dashboardComponent.isTasksViewActive = false;
      this.dashboardComponent.isTaskDetailViewActive = false;
      this.dashboardComponent.isGradeSubjectViewActive = false
      this.dashboardComponent.isClassroomViewActive = true;
      this.dashboardComponent.isModuleCategoryViewActive = false;
      this.dashboardComponent.isSubjectsViewActive = false;
      this.dashboardComponent.subjectViewActive = false;
      this.updateBreadcrumbs("remove", "backToClassroom");
    },
    updateBreadcrumbs(method, param) {
      var self = this;
      switch (method) {
        case "add":
          if(param.text == "home" && self.breadcrumbs.length != 0 && self.breadcrumbs[0].text == "home")
            break
          self.breadcrumbs.push(param);
          break;
        case "remove":
          var indexToCutOff = self.breadcrumbs.findIndex(function(x) { return x.clickFunction == param });
          self.breadcrumbs.splice(indexToCutOff + 1);
          break;
        default:
          break;
      }
    },
    toggleSideBar(){
      this.isSideBarBactive = !this.isSideBarBactive;
    },
    onResize(){
      this.windowWidth = window.innerWidth;
    }
  },
  components: {
    TheNavbar,
    TheFooter,
    BackToTop,
  },
  created() {
    document.title = "DigiCampus";
    this.setSidebarWidth();
    if (this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }

    this.$store.dispatch("updateTheme", "dark");

    this.$setSchoolTheme();
    this.updateTheme();
    this.virtualClassroom();
  },
  mounted(){
    this.dashboardComponent = this.$children.filter(function(x) {return x.name == "TeacherDashboard"})[0];
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  }
};
</script>
<style lang="scss">
@import "../assets/FabStylesheet_1.scss";
@import "../assets/FabStylesheet_2.scss";
.vx-navbar-wrapper {
  background: none !important;
  padding: 2.2rem;
  padding-top: 1.3rem;
  z-index: 41000;
  height: 103px;
  position: relative;
  top: 0;
}
.vs-navbar.vx-navbar {
  background: linear-gradient(to bottom right, rgba(var(--vs-primary),1), rgba(var(--vs-secondary),1)) !important;
  padding: 0.8rem 1rem;
  width: calc(100% - 4.7rem);
  position: fixed;
  border-radius: 2.1rem;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  z-index: 10000;
}

#teacher-view.router-view {
  padding: 0 !important;
  padding-left: 2.2rem !important;
  top: 0 !important;
  width: calc(100% - 3.2rem);

  .router-content {
    margin-top: 0 !important;
    text-align: -webkit-left !important;
    text-align: -moz-left !important;
    margin-left: 270px !important;

    .content-area__content {
      text-align: -webkit-center !important;
      text-align: -moz-center !important;
    }
  }

  @media screen and (max-width: 700px) {
    .router-content {
      margin-left: 50px !important;
    }
  }
}

* {
  font-family: Montserrat;
}

.bread-crumbs-container{
  .bread-crumbs-Item:last-child{
    height: fit-content !important;
  }
}

#teacher-dashboard{
  .side-nav-active-router-view{
    width: 95% !important;
    margin: auto !important;
    padding: 0px !important;
    padding-left: 0px !important;
  }

  .side-nav-active{
    position: fixed;
    z-index: 200;
    width: 300px;
    display: block !important;
    box-shadow: 0px 4px 8px 0px black !important;
  }
  @media screen and(max-width:837px){
    #teacher-view.router-view{
      padding-left: 0px !important;
    }
    .teacher__side-menu:not(.side-nav-active){
      width: 0px;
      z-index: 200;
    }
    .router-view{
      width: 95% !important;
      margin: auto !important;
      padding-left: 0px !important;
    }
    .side-nav-active{
      p{
        display: block !important;
      }
    }
    .teacher__side-menu{
      height: 100vh;
      overflow: auto;
    }
    .router-content{
      width: 95% !important;
      margin-left: 0px !important;
      margin: auto !important;
      padding-left: 0px !important;
    }
  }
}

#teacher-view.router-view {
  padding: 0 !important;
  padding-left: 2.2rem !important;
  top: 0 !important;
  width: calc(100% - 3.2rem);

  .router-content {
    margin-top: 0 !important;
    text-align: -webkit-left !important;
    text-align: -moz-left !important;
    margin-left: 270px !important;

    .content-area__content {
      text-align: -webkit-center !important;
      text-align: -moz-center !important;
    }
  }

  @media screen and (max-width: 700px) {
    .router-content {
      margin-left: 0px !important;
    }
  }
}

#teacher-view.router-view .router-content:where(.smaller-content-area){
  width: 95% !important;
  margin-left: 0px !important;
  margin: auto !important;
  padding-left: 0px !important;
}
</style>